<template>
  <v-row no-gutters
         class="std-container-shadow std-border-radius">
    <v-col cols="12"
           class="header-container std-background-blue-2 d-flex align-center justify-center std-border-top-radius">
      <div class="pa-0 font-weight-bold" style="font-size: 1.25rem;">{{header}}</div>
    </v-col>
    <v-col cols="12"
           class="img-container d-flex align-center">
      <v-img :src="img"
             max-height="90%"
             contain>
      </v-img>
    </v-col>
    <v-col cols="12"
           class="counter-container align-center justify-center d-flex">
      <div class="font-weight-medium std-text-blue-3 unselectable">{{counter}}</div>
    </v-col>
    <v-col cols="12"
           class="footer-container unselectable std-text-md  std-text-blue-3 d-flex align-center justify-center std-pointer font-weight-medium">Ver más
    </v-col>
  </v-row>
</template>

<script>
    export default {
        name: "HomeSmallCard",
        props: ['header', 'img', 'counter', 'view'],
    }
</script>

<style scoped>
  .header-container {
    height: 40px;
    color: #FFFFFF;
  }

  .img-container {
    height: 116px;
  }

  .counter-container {
    height: 64px;
    font-size: 4rem;
  }

  .footer-container {
    height: 24px;
  }

  .footer-container:hover {
    text-decoration: underline;
  }

</style>